import Dashboard from "../Dashboard";
import Layout from "../../../components/Layout";

export default function Funcs() {
  return Layout(Dashboard, "Funcionarios");
}
